import { render, staticRenderFns } from "./ObjectCard.vue?vue&type=template&id=43aa05c6&scoped=true&"
import script from "./ObjectCard.vue?vue&type=script&lang=js&"
export * from "./ObjectCard.vue?vue&type=script&lang=js&"
import style0 from "./ObjectCard.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ObjectCard.vue?vue&type=style&index=1&id=43aa05c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43aa05c6",
  null
  
)

export default component.exports
import {QCard,QCardSection,QToolbar,QToolbarTitle,QTooltip,QBtn,QTabs,QTab,QItem,QItemLabel,QBadge,QInnerLoading,QSpinnerGears,QField} from 'quasar'
component.options.components = Object.assign({QCard,QCardSection,QToolbar,QToolbarTitle,QTooltip,QBtn,QTabs,QTab,QItem,QItemLabel,QBadge,QInnerLoading,QSpinnerGears,QField}, component.options.components || {})
